import { localStorage } from '@rover/utilities/storage';

/**
 * `'shortlist'` mirrors SHORTLIST_STORAGE_KEY in components/src/shortlist/constants, and
 * `'roverContactDraft'` mirrors STORAGE_KEY in react-lib's AccountPhonesForm/draft/
 * contactDraftCache. We don't import either file to avoid a dependency cycle, but there are
 * drift guard tests in components/src/shortlist/constants.test.ts and in
 * AccountPhonesForm/draft/contactDraftCache.test.ts.
 *
 * The contact draft is written on the way into an account interception, so it has to outlive
 * the very logout that sends the user to the sign-in page.
 */
export const LOGOUT_PRESERVED_KEYS = ['shortlist', 'roverContactDraft'];

export const getItem = (key: string): string | null => localStorage.getItem(key);

export const setItem = (key: string, value: string): void => localStorage.setItem(key, value);

export const removeItem = (key: string): void => localStorage.removeItem(key);

export const clear = (): void => localStorage.clear();

/**
 * Clears localStorage on logout while retaining LOGOUT_PRESERVED_KEYS.
 * Iterating from the end avoids re-indexing as `removeItem` shrinks the store.
 */
export const clearOnLogout = (): void => {
  const preserved = new Set(LOGOUT_PRESERVED_KEYS);
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i);
    if (key !== null && !preserved.has(key)) {
      localStorage.removeItem(key);
    }
  }
};
